var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "reduce-modal",
    attrs: {
      title: _vm.$t("减员确认"),
      visible: _vm.showVisible,
      width: 600
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("姓名"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件号码"),
      prop: "idNumber"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.form.idNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "idNumber", $$v);
      },
      expression: "form.idNumber"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "endAt"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.$t("责任止期")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "bottomLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" 责任止期：为当前人员最后一天在保日期，如不显示时间 则默认到当天24时。 ")]), _c("a-icon", {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-date-picker", {
    attrs: {
      format: _vm.getFormatDate(),
      disabled: _vm.form.declarationMethod == "DAY",
      "disabled-date": _vm.disabledDate
    },
    on: {
      change: _vm.onChangeTime
    },
    model: {
      value: _vm.form.endAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "endAt", $$v);
      },
      expression: "form.endAt"
    }
  })], 2), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("在保期"),
      prop: "endAt"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.endAt ? _vm.showDate + (_vm.isSame ? "" : 24 + _vm.$t("时")) : "-"))])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应退保费"),
      prop: "endAt"
    }
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.form.endAt ? _vm.showPrice : "-"))]), _vm._v(" 元 ")])], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("cancel");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.saveReduce
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };